if (quickAddLoaded === undefined) {
  var quickAddLoaded = true;
  $(document).ready(function () {
    $('.product-form form').on('submit', function (e) {
      e.preventDefault();
      var $form = $(this);

      $form.find('.error-message').remove();

      const submitButton = $form.find('[type="submit"]');

      submitButton.attr('disabled', true);
      submitButton.addClass('loading');

      let properties = {};
      const $scope = $form.closest('.product-form').length ? $form.closest('.product-form') : $form;
      const frequency = $scope.find('.rc_widget__option__input:checked').val();
      const sellingPlan =
        $scope.find('.rc-selling-plans__dropdown').val() ||
        $scope.find('.rc_widget__option__plans__dropdown').val() ||
        $scope.find('select[name="selling_plan"]').val() ||
        $scope.find('input[name="selling_plan"]').val();

      if (frequency === 'onetime') {
        // Explicit one-time purchase — no selling plan
      } else if (frequency === 'subsave' && sellingPlan) {
        properties = { selling_plan: sellingPlan };
      } else if (sellingPlan && $scope.find('.rc_widget__option__input[value="onetime"]').length === 0) {
        // Subscription-only products: no onetime radio, but frequency dropdown is present
        properties = { selling_plan: sellingPlan };
      }

      const variantId = $form.find('.js-variant-id').val();
      const quantity = $scope.find('.js-quantity-select').val() || $('.js-quantity-select').val() || 1;

      CartJS.addItem(variantId, quantity, properties, {
        // Define a success callback to display a success message.
        "success": function(data, textStatus, jqXHR) {
          $('body').addClass('open-cart');
          submitButton.removeClass('loading');
          submitButton.attr('disabled', false);
        },
        // Define an error callback to display an error message.
        "error": function(jqXHR, textStatus, errorThrown) {
          $form.append('<p class="error-message">' + jqXHR.responseJSON.description + '</p>');
          submitButton.removeClass('loading');
          submitButton.attr('disabled', false);
        }
      });
    });

  });



  // The waitlist form opens under this button. It used to just fadeIn(), which
  // reads as nothing happening: the form is a 29px input whose label is
  // visually hidden, and a second click on an already-open form did literally
  // nothing at all. Clarity logged 201 dead clicks on this button in two weeks,
  // all on The Masher, every one of them a customer trying to leave an email
  // address on an out-of-stock product.
  //
  // So: reveal it, then put the caret in the field. Focus is what makes the
  // reveal legible. It raises the keyboard on mobile, which is where most of
  // this traffic is, and it gives a repeat click something to do rather than
  // nothing.
  $('.js-open-notify-me').on('click', function (e) {
    e.preventDefault();

    var $form = $('.js-notify-me-form-wrapper');
    if (!$form.length) return;

    var focusEmail = function () {
      var input = $form.find('[name="email"]')[0];
      if (!input) return;
      // scroll first, then focus, so the field is not left under the keyboard
      if (input.getBoundingClientRect().bottom > window.innerHeight * 0.6) {
        input.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
      try { input.focus({ preventScroll: true }); } catch (err) { input.focus(); }
    };

    if ($form.is(':visible')) {
      focusEmail();
      return;
    }
    $form.fadeIn(200, focusEmail);
  });

  /* ---------------------------------------------
  OOS / COMING SOON NOTIFICATIONS
  ------------------------------------------------ */

  $('.js-notify-me-form-wrapper').on( 'submit', function (e) {
    e.preventDefault();
    var $form = $(this);
    // var formType = $form.attr('data-form');
    var formType = 'pre-launch';
    var klaviyoListId = $form.attr('data-list-id') ? $form.attr('data-list-id') : 'WRqTkf';
    var email = $form.find('[name="email"]').val();
    var origin = '';
    var signupUrl = formType == 'pre-launch' ? 'https://a.klaviyo.com/ajax/subscriptions/subscribe' : 'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe';
    var data;

    if (formType == 'pre-launch') {
      var data = {
        'g': klaviyoListId,
        "$fields": "$source,$consent,product,variant,Product Name",
        '$consent': 'web',
        '$consent_method': 'Waitist Form',
        'email': email,
        '$timezone_offset': Math.abs(new Date().getTimezoneOffset() / 60),
        'variant': $form.find('[name="email"]').attr('data-variant-id'),
        'product': $form.find('[name="email"]').attr('data-product-id'),
        'Product Name': $form.find('[name="email"]').attr('data-product-name'),
        '$source': 'PDP Waitlist',
      };


    } else {
      // 'a' is public api key from Klaviyo account settings
      var data = {
        'g': klaviyoListId,
        'a': 'WRqTkf',
        'platform': 'shopify',
        '$consent': 'web',
        '$consent_method': 'Waitist Form',
        'email': email,
        '$timezone_offset': Math.abs(new Date().getTimezoneOffset() / 60),
        'variant': $form.find('[name="email"]').attr('data-variant-id'),
        'product': $form.find('[name="email"]').attr('data-product-id'),
        'Product Name': $form.find('[name="email"]').attr('data-product-name'),
        '$source': 'PDP Waitlist',
      };
    }

    $.ajax({
      method: 'POST',
      url: signupUrl,
      data: data
    }).done(function (response) {
      if (response.success) {
        $form.find('.field').hide();
        $form.find('button').hide();
        $form.find('.signup-success').fadeIn();
      } else {
        console.error('Error Klaviyo: ', response.errors);
        $form.find('.field').hide();
        $form.find('button').hide();
        $form.find('.signup-errror').fadeIn();
      }
    }).fail(function (err) {
      console.error('Error Klaviyo: ', err);
      // $form.find('.form-inputs').hide();
      $form.find('.signup-errror').html(err).fadeIn();
    });
  });

}
